import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setCreditLimit = async (context, trade) => {
  const { data } = await api().post('inventory.post-credit-limit', trade);
  context.commit(types.SET_CREDIT_LIMIT, data);

  return data;
};
